var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ship-graph-combat',{staticClass:"mx-auto",staticStyle:{"width":"40rem","height":"40rem"},attrs:{"ship-types":Object.values(_vm.shipTypes)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }